<template>
  <div class="menu-mobile" @click="$emit('close')">
    <div class="menu-content box-bg-1">
      <div
        class="menu-item text-gray-1"
        v-for="(navItem, index) in mobileDropDownList"
        :key="index"
        @click.stop="onNavItem(navItem)"
      >
        <div class="menu-item-title d-flex ai-center jc-center">
          <img class="icon" v-if="navItem.icon" :src="navItem.icon" />
          <div>{{ navItem.title }}</div>
          <!-- <img
            class="arrow-down"
            :class="{ active: navItem.isShow }"
            v-if="navItem.children"
            src="../assets/menumobile/arrow-down.png"
          /> -->
        </div>
        <div class="nav-item-list-box" v-if="navItem.isShow">
          <div
            class="nav-item-list"
            v-for="(langItem, index) in navItem.children"
            :key="index"
          >
            <div
              class="text title d-flex ai-center jc-center"
              :data-lang="langItem.lang"
            >
              {{ langItem.langText }}
            </div>
            <div :class="{ line: index !== navItem.children.length - 1 }"></div>
          </div>
        </div>
        <div
          :class="{
            line: index !== mobileDropDownList.length - 1 && !navItem.isShow,
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['isDark']),
    mobileDropDownList() {
      let str = ''
      this.isDark ? (str = '-dark') : ''
      return [
        {
          title: this.$t('swap'),
          url: 'http://swap.transit.finance/',
        },
        {
          title: this.$t('buyToken'),
          url: 'https://buy.transit.finance/',
        },
        {
          title: this.$t('security'),
          url: 'https://tokensecurity.tokenpocket.pro/',
        },
        {
          icon:
            this.$i18n.locale === 'en'
              ? require(`../assets/en${str}.png`)
              : require(`../assets/zh${str}.png`),
          language: true,
          title: this.$t('language'),
        },
        {
          icon: this.isDark
            ? require(`../assets/moon${str}.png`)
            : require(`../assets/sun${str}.png`),
          mode: true,
          title: this.isDark ? this.$t('darkTheme') : this.$t('lightTheme'),
        },
      ]
    },
  },

  methods: {
    onNavItem(navItem) {
      if (navItem.url) {
        window.open(navItem.url, '_self')
      } else if (navItem.children) {
        navItem.isShow = !navItem.isShow
      } else if (navItem.language) {
        this.onChangeLang()
      } else if (navItem.mode) {
        this.changeMode()
      }
      this.$emit('close')
    },
    onChangeLang() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh'
      } else {
        this.$i18n.locale = 'en'
      }
    },
    changeMode() {
      this.$store.commit('setDark', !this.isDark)
      if (!document.documentElement.hasAttribute('theme')) {
        document.documentElement.setAttribute('theme', 'dark')
        window.localStorage.setItem('mode', 'dark')
      } else {
        document.documentElement.removeAttribute('theme')
        window.localStorage.setItem('mode', 'light')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-mobile {
  position: fixed;
  z-index: 9997;
  top: 1.3rem;
  left: 0;
  width: 100vw;
  height: calc(100vh - 1.3rem);
  background: rgba(0, 0, 0, 0.5);
  .menu-content {
    width: 100vw;
    .menu-item {
      font-size: 0.24rem;
      .menu-item-title {
        height: 0.99rem;
        .icon {
          margin-right: 0.16rem;
          width: 0.32rem;
          height: 0.32rem;
        }
        .arrow-down {
          transform-origin: center center;
          transform: rotate(-90deg);
          width: 0.3rem;
          height: 0.3rem;
          &.active {
            transform: rotate(0);
          }
        }
      }
      .line {
        width: 94vw;
        margin: 0 auto;
        height: 0.01rem;
      }
      .nav-item-list-box {
        background: #f7f5ff;
        .nav-item-list {
          .title {
            height: 0.99rem;
            text-align: center;
            font-size: 0.24rem;
          }
          .line {
            background: #fff;
          }
        }
      }
    }
  }
}
</style>
